export default __webpack_public_path__ + "static/microsoft-c59c4c7873ebbb76e6d64abb42f48783.png";